import { Navigate, useParams } from 'react-router-dom';
import { appPath } from './paths';

/** Sends `#/leads/:id` (and similar) to `/app/leads/:id`. */
export function LegacyLeadsDetailRedirect() {
  const { id } = useParams();
  return <Navigate to={appPath(id ? `/leads/${id}` : '/leads')} replace />;
}

/** Sends `#/kundali/:id` to `/app/kundali/:id`. */
export function LegacyKundaliRedirect() {
  const { id } = useParams();
  return <Navigate to={appPath(id ? `/kundali/${id}` : '/contacts')} replace />;
}

/** Sends legacy `#/settings/...` or `#/setup/...` to `/app/setup/...`. */
export function LegacySettingsRedirect() {
  const { '*': rest } = useParams();
  const suffix = rest?.replace(/^\//, '') ?? '';
  return <Navigate to={suffix ? appPath(`/setup/${suffix}`) : appPath('/setup')} replace />;
}

/** Sends `/app/settings/...` to `/app/setup/...`. */
export function AppSettingsToSetupRedirect() {
  const { '*': rest } = useParams();
  const suffix = rest?.replace(/^\//, '') ?? '';
  return <Navigate to={suffix ? appPath(`/setup/${suffix}`) : appPath('/setup')} replace />;
}
